// extracted by mini-css-extract-plugin
export default {"filter":"PropertiesFilter_filter__IZdo2"};